// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-form-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.public-form {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  padding: 30px 30px 100px 30px;
  max-width: 1000px;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  position: relative;
  overflow-x: hidden; /* Prevent horizontal scroll */
}

.form-header {
  text-align: center;
  margin-bottom: 20px;
}

.form-header h1 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 28px;
  font-weight: 600;
}

.form-description {
  margin: 0;
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

/* Lawyer Info Header */
.lawyer-info-header {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  text-align: left;
}

.lawyer-info-header h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #007bff;
  padding-bottom: 8px;
}

.lawyer-info-header p {
  margin: 8px 0;
  color: #555;
  font-size: 14px;
  line-height: 1.4;
}

.lawyer-info-header strong {
  color: #333;
  font-weight: 600;
  min-width: 80px;
  display: inline-block;
}

/* Alerts */
.alert {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
}

.alert-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Form */
.intake-form {
  margin-bottom: 20px;
}

.form-field {
  margin-bottom: 20px;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 15px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 2px 0;
}

.required {
  color: #dc3545;
  margin-left: 2px;
}

.field-help {
  display: block;
  margin-top: 3px;
  color: #666;
  font-size: 12px;
}

/* Form Inputs */
.form-input,
.form-textarea,
.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.2s;
  background: white;
  box-sizing: border-box;
  max-width: 100%;
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Form Actions */
.form-actions {
  margin-top: 30px;
  text-align: center;
  position: relative;
  z-index: 100;
}

/* Sticky Submit Bar */
.sticky-submit-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(102, 126, 234, 0.2);
  padding: 12px 24px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -8px 32px rgba(102, 126, 234, 0.15);
  border-radius: 20px 20px 0 0;
}

.progress-info {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #667eea;
  font-size: 14px;
  font-weight: 500;
}

.progress-indicator {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border: 2px solid rgba(102, 126, 234, 0.3);
  border-radius: 24px;
  padding: 8px 16px;
  font-size: 12px;
  color: #667eea;
  font-weight: 600;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
}

.sticky-submit-button {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  backdrop-filter: blur(8px);
}

.sticky-submit-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(16, 185, 129, 0.4);
}

.sticky-submit-button:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);
  opacity: 0.6;
}

.btn-submit,
.submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 16px 40px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 220px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}

.btn-submit:hover:not(:disabled),
.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.btn-submit:disabled,
.submit-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Form Footer */
.form-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.privacy-note {
  margin: 0;
  color: #666;
  font-size: 12px;
  line-height: 1.4;
}

.closing-note {
  font-size: 14px;
  opacity: 0.7;
  font-style: italic;
}

/* Field Groups */
.field-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.sub-field {
  display: flex;
  flex-direction: column;
}

.sub-field-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.sub-field .form-input,
.sub-field .form-select {
  width: 100%;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .public-form {
    max-width: 800px;
    padding: 35px 30px;
  }
}

@media (max-width: 768px) {
  .public-form-container {
    padding: 10px;
  }
  
  .public-form {
    max-width: 100%;
    padding: 25px 20px;
    border-radius: 8px;
  }
  
  .form-header h1 {
    font-size: 24px;
  }
  
  .form-description {
    font-size: 14px;
  }
  
  .btn-submit,
  .submit-button {
    width: 100%;
    min-width: auto;
  }
  
  .sticky-submit-bar {
    padding: 12px 15px;
  }
  
  .progress-info {
    gap: 10px;
    font-size: 13px;
  }
  
  .sticky-submit-button {
    padding: 10px 20px;
    min-width: 120px;
    font-size: 15px;
  }
  
  .field-group {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .public-form {
    padding: 20px 15px;
  }
  
  .form-header h1 {
    font-size: 20px;
  }
  
  .form-input,
  .form-textarea,
  .form-select {
    padding: 12px 14px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
  
  .sticky-submit-bar {
    padding: 10px 12px;
  }
  
  .progress-info {
    flex-direction: column;
    gap: 5px;
    font-size: 12px;
    align-items: flex-start;
  }
  
  .sticky-submit-button {
    padding: 10px 16px;
    min-width: 100px;
    font-size: 14px;
  }
  
  .form-field {
    margin-bottom: 18px;
  }
} 

/* Responsive adjustments for field groups */
@media (max-width: 768px) {
  .field-group {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  /* Tab Navigation - Mobile Optimization */
  .form-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
  }
  
  .form-tabs::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  
  .tab-button {
    padding: 12px 20px;
    font-size: 15px;
    white-space: nowrap;
    min-width: max-content;
  }
} 

/* Tab Navigation */
.form-tabs {
  display: flex;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 30px;
  margin-top: 20px;
}

.tab-button {
  background: none;
  border: none;
  padding: 15px 25px;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-button:hover {
  color: #667eea;
  background-color: #f8f9fa;
}

.tab-button.active {
  color: #667eea;
  border-bottom-color: #667eea;
  background-color: #f8f9fa;
}

/* Tab Content */
.tab-content {
  min-height: 400px;
  animation: fadeIn 0.3s ease-in-out;
  padding-bottom: 80px; /* Space for sticky bar */
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-fields-tab {
  padding: 0;
}

.document-upload-tab {
  padding: 20px 0;
}

.document-upload-tab .document-upload-section {
  margin-bottom: 0;
}

/* ========================================
   ENHANCED MOBILE IMPROVEMENTS
   Matching consultation form quality
   ======================================== */

/* Touch Target Improvements - All Mobile Devices */
@media (hover: none) and (pointer: coarse) {
  /* Better touch targets for mobile devices */
  input[type="text"],
  input[type="email"],
  input[type="tel"],
  input[type="date"],
  input[type="number"],
  textarea,
  select {
    min-height: 44px; /* Apple's recommended touch target */
    font-size: 16px !important; /* Ensures iOS zoom prevention everywhere */
  }
  
  .btn-submit,
  .submit-button,
  .sticky-submit-button {
    min-height: 48px; /* Larger for primary action */
  }
  
  .tab-button {
    min-height: 44px;
    padding: 12px 20px;
  }
  
  /* Remove hover effects on touch devices */
  input:hover,
  textarea:hover,
  select:hover {
    border-color: #e9ecef; /* Keep default, no hover */
  }
  
  .tab-button:hover {
    background-color: transparent; /* No hover on touch */
  }
  
  .tab-button.active:hover {
    background-color: #f8f9fa; /* Keep active state */
  }
}

/* Landscape Phones (≤ 667px height) */
@media (max-height: 667px) and (orientation: landscape) {
  .public-form-container {
    padding: 10px;
  }
  
  .public-form {
    padding: 20px 25px 80px 25px;
    max-height: 90vh;
  }
  
  .form-header {
    margin-bottom: 15px;
  }
  
  .form-header h1 {
    font-size: 22px;
  }
  
  .form-field {
    margin-bottom: 15px;
  }
  
  textarea {
    min-height: 80px;
  }
  
  .sticky-submit-bar {
    padding: 10px 12px;
  }
  
  .tab-content {
    min-height: 300px;
  }
}

/* Enhanced Mobile Optimization for Tabs */
@media (max-width: 640px) {
  .form-tabs {
    margin-bottom: 20px;
    margin-top: 15px;
  }
  
  .tab-button {
    padding: 10px 16px;
    font-size: 14px;
    gap: 6px;
  }
  
  .tab-button svg {
    width: 16px;
    height: 16px;
  }
}

/* Extra Small Phones (≤ 360px) */
@media (max-width: 360px) {
  .public-form-container {
    padding: 8px;
  }
  
  .public-form {
    padding: 15px 12px 80px 12px;
    border-radius: 8px;
  }
  
  .form-header h1 {
    font-size: 18px;
  }
  
  .form-description {
    font-size: 13px;
  }
  
  .lawyer-info-header {
    padding: 15px;
  }
  
  .tab-button {
    padding: 10px 12px;
    font-size: 13px;
  }
  
  .sticky-submit-button {
    padding: 10px 14px;
    min-width: 90px;
    font-size: 13px;
  }
  
  .progress-info {
    font-size: 11px;
  }
}

/* Print Styles - Hide unnecessary elements */
@media print {
  .sticky-submit-bar,
  .form-tabs {
    display: none !important;
  }
  
  .public-form-container {
    background: white;
    padding: 0;
  }
  
  .public-form {
    box-shadow: none;
    border: 1px solid #e5e7eb;
    max-height: none;
    padding-bottom: 0;
  }
  
  .tab-content {
    padding-bottom: 0;
  }
  
  /* Show all tabs content when printing */
  .document-upload-tab {
    display: block !important;
  }
}

/* Accessibility - Focus Visible States */
@media (prefers-reduced-motion: no-preference) {
  input:focus-visible,
  textarea:focus-visible,
  select:focus-visible {
    outline: 2px solid #667eea;
    outline-offset: 2px;
  }
  
  .tab-button:focus-visible {
    outline: 2px solid #667eea;
    outline-offset: -2px;
  }
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  input,
  textarea,
  select {
    border-width: 2px;
  }
  
  .btn-submit,
  .submit-button,
  .sticky-submit-button {
    border: 2px solid currentColor;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PublicIntakeForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,+FAA+F;EAC/F,2BAA2B;EAC3B,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8FAA8F;EAC9F,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,YAAY;AACd;;AAEA;;EAEE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;EAEE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA,yCAAyC;EACzC;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB,EAAE,YAAY;EACrC;;EAEA;IACE,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB,EAAE,yBAAyB;AACjD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;6CAG6C;;AAE7C,mDAAmD;AACnD;EACE,4CAA4C;EAC5C;;;;;;;IAOE,gBAAgB,EAAE,qCAAqC;IACvD,0BAA0B,EAAE,2CAA2C;EACzE;;EAEA;;;IAGE,gBAAgB,EAAE,8BAA8B;EAClD;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,0CAA0C;EAC1C;;;IAGE,qBAAqB,EAAE,2BAA2B;EACpD;;EAEA;IACE,6BAA6B,EAAE,sBAAsB;EACvD;;EAEA;IACE,yBAAyB,EAAE,sBAAsB;EACnD;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,YAAY;EACd;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;IACE,yBAAyB;EAC3B;AACF;;AAEA,yCAAyC;AACzC;EACE;;;IAGE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;AACF;;AAEA,+BAA+B;AAC/B;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;;;IAGE,8BAA8B;EAChC;AACF","sourcesContent":[".public-form-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.public-form {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n  padding: 30px 30px 100px 30px;\n  max-width: 1000px;\n  width: 100%;\n  max-height: 95vh;\n  overflow-y: auto;\n  position: relative;\n  overflow-x: hidden; /* Prevent horizontal scroll */\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.form-header h1 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.form-description {\n  margin: 0;\n  color: #666;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n/* Lawyer Info Header */\n.lawyer-info-header {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 20px;\n  text-align: left;\n}\n\n.lawyer-info-header h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 2px solid #007bff;\n  padding-bottom: 8px;\n}\n\n.lawyer-info-header p {\n  margin: 8px 0;\n  color: #555;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.lawyer-info-header strong {\n  color: #333;\n  font-weight: 600;\n  min-width: 80px;\n  display: inline-block;\n}\n\n/* Alerts */\n.alert {\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.alert-error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Form */\n.intake-form {\n  margin-bottom: 20px;\n}\n\n.form-field {\n  margin-bottom: 20px;\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n  font-size: 15px;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n  padding: 2px 0;\n}\n\n.required {\n  color: #dc3545;\n  margin-left: 2px;\n}\n\n.field-help {\n  display: block;\n  margin-top: 3px;\n  color: #666;\n  font-size: 12px;\n}\n\n/* Form Inputs */\n.form-input,\n.form-textarea,\n.form-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e9ecef;\n  border-radius: 10px;\n  font-size: 15px;\n  transition: all 0.2s;\n  background: white;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.form-input:focus,\n.form-textarea:focus,\n.form-select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n/* Form Actions */\n.form-actions {\n  margin-top: 30px;\n  text-align: center;\n  position: relative;\n  z-index: 100;\n}\n\n/* Sticky Submit Bar */\n.sticky-submit-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%);\n  backdrop-filter: blur(20px);\n  border-top: 1px solid rgba(102, 126, 234, 0.2);\n  padding: 12px 24px;\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 -8px 32px rgba(102, 126, 234, 0.15);\n  border-radius: 20px 20px 0 0;\n}\n\n.progress-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  color: #667eea;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.progress-indicator {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n  border: 2px solid rgba(102, 126, 234, 0.3);\n  border-radius: 24px;\n  padding: 8px 16px;\n  font-size: 12px;\n  color: #667eea;\n  font-weight: 600;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);\n}\n\n.sticky-submit-button {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  color: white;\n  border: none;\n  padding: 12px 28px;\n  border-radius: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3);\n  min-width: 160px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  backdrop-filter: blur(8px);\n}\n\n.sticky-submit-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-3px);\n  box-shadow: 0 8px 28px rgba(16, 185, 129, 0.4);\n}\n\n.sticky-submit-button:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);\n  opacity: 0.6;\n}\n\n.btn-submit,\n.submit-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 16px 40px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  min-width: 220px;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);\n}\n\n.btn-submit:hover:not(:disabled),\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.btn-submit:disabled,\n.submit-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Form Footer */\n.form-footer {\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid #e9ecef;\n}\n\n.privacy-note {\n  margin: 0;\n  color: #666;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.closing-note {\n  font-size: 14px;\n  opacity: 0.7;\n  font-style: italic;\n}\n\n/* Field Groups */\n.field-group {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.sub-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.sub-field-label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.sub-field .form-input,\n.sub-field .form-select {\n  width: 100%;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .public-form {\n    max-width: 800px;\n    padding: 35px 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .public-form-container {\n    padding: 10px;\n  }\n  \n  .public-form {\n    max-width: 100%;\n    padding: 25px 20px;\n    border-radius: 8px;\n  }\n  \n  .form-header h1 {\n    font-size: 24px;\n  }\n  \n  .form-description {\n    font-size: 14px;\n  }\n  \n  .btn-submit,\n  .submit-button {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .sticky-submit-bar {\n    padding: 12px 15px;\n  }\n  \n  .progress-info {\n    gap: 10px;\n    font-size: 13px;\n  }\n  \n  .sticky-submit-button {\n    padding: 10px 20px;\n    min-width: 120px;\n    font-size: 15px;\n  }\n  \n  .field-group {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .public-form {\n    padding: 20px 15px;\n  }\n  \n  .form-header h1 {\n    font-size: 20px;\n  }\n  \n  .form-input,\n  .form-textarea,\n  .form-select {\n    padding: 12px 14px;\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n  \n  .sticky-submit-bar {\n    padding: 10px 12px;\n  }\n  \n  .progress-info {\n    flex-direction: column;\n    gap: 5px;\n    font-size: 12px;\n    align-items: flex-start;\n  }\n  \n  .sticky-submit-button {\n    padding: 10px 16px;\n    min-width: 100px;\n    font-size: 14px;\n  }\n  \n  .form-field {\n    margin-bottom: 18px;\n  }\n} \n\n/* Responsive adjustments for field groups */\n@media (max-width: 768px) {\n  .field-group {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n  \n  /* Tab Navigation - Mobile Optimization */\n  .form-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; /* Firefox */\n  }\n  \n  .form-tabs::-webkit-scrollbar {\n    display: none; /* Chrome, Safari */\n  }\n  \n  .tab-button {\n    padding: 12px 20px;\n    font-size: 15px;\n    white-space: nowrap;\n    min-width: max-content;\n  }\n} \n\n/* Tab Navigation */\n.form-tabs {\n  display: flex;\n  border-bottom: 2px solid #e9ecef;\n  margin-bottom: 30px;\n  margin-top: 20px;\n}\n\n.tab-button {\n  background: none;\n  border: none;\n  padding: 15px 25px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tab-button:hover {\n  color: #667eea;\n  background-color: #f8f9fa;\n}\n\n.tab-button.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n  background-color: #f8f9fa;\n}\n\n/* Tab Content */\n.tab-content {\n  min-height: 400px;\n  animation: fadeIn 0.3s ease-in-out;\n  padding-bottom: 80px; /* Space for sticky bar */\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.form-fields-tab {\n  padding: 0;\n}\n\n.document-upload-tab {\n  padding: 20px 0;\n}\n\n.document-upload-tab .document-upload-section {\n  margin-bottom: 0;\n}\n\n/* ========================================\n   ENHANCED MOBILE IMPROVEMENTS\n   Matching consultation form quality\n   ======================================== */\n\n/* Touch Target Improvements - All Mobile Devices */\n@media (hover: none) and (pointer: coarse) {\n  /* Better touch targets for mobile devices */\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"tel\"],\n  input[type=\"date\"],\n  input[type=\"number\"],\n  textarea,\n  select {\n    min-height: 44px; /* Apple's recommended touch target */\n    font-size: 16px !important; /* Ensures iOS zoom prevention everywhere */\n  }\n  \n  .btn-submit,\n  .submit-button,\n  .sticky-submit-button {\n    min-height: 48px; /* Larger for primary action */\n  }\n  \n  .tab-button {\n    min-height: 44px;\n    padding: 12px 20px;\n  }\n  \n  /* Remove hover effects on touch devices */\n  input:hover,\n  textarea:hover,\n  select:hover {\n    border-color: #e9ecef; /* Keep default, no hover */\n  }\n  \n  .tab-button:hover {\n    background-color: transparent; /* No hover on touch */\n  }\n  \n  .tab-button.active:hover {\n    background-color: #f8f9fa; /* Keep active state */\n  }\n}\n\n/* Landscape Phones (≤ 667px height) */\n@media (max-height: 667px) and (orientation: landscape) {\n  .public-form-container {\n    padding: 10px;\n  }\n  \n  .public-form {\n    padding: 20px 25px 80px 25px;\n    max-height: 90vh;\n  }\n  \n  .form-header {\n    margin-bottom: 15px;\n  }\n  \n  .form-header h1 {\n    font-size: 22px;\n  }\n  \n  .form-field {\n    margin-bottom: 15px;\n  }\n  \n  textarea {\n    min-height: 80px;\n  }\n  \n  .sticky-submit-bar {\n    padding: 10px 12px;\n  }\n  \n  .tab-content {\n    min-height: 300px;\n  }\n}\n\n/* Enhanced Mobile Optimization for Tabs */\n@media (max-width: 640px) {\n  .form-tabs {\n    margin-bottom: 20px;\n    margin-top: 15px;\n  }\n  \n  .tab-button {\n    padding: 10px 16px;\n    font-size: 14px;\n    gap: 6px;\n  }\n  \n  .tab-button svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n/* Extra Small Phones (≤ 360px) */\n@media (max-width: 360px) {\n  .public-form-container {\n    padding: 8px;\n  }\n  \n  .public-form {\n    padding: 15px 12px 80px 12px;\n    border-radius: 8px;\n  }\n  \n  .form-header h1 {\n    font-size: 18px;\n  }\n  \n  .form-description {\n    font-size: 13px;\n  }\n  \n  .lawyer-info-header {\n    padding: 15px;\n  }\n  \n  .tab-button {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n  \n  .sticky-submit-button {\n    padding: 10px 14px;\n    min-width: 90px;\n    font-size: 13px;\n  }\n  \n  .progress-info {\n    font-size: 11px;\n  }\n}\n\n/* Print Styles - Hide unnecessary elements */\n@media print {\n  .sticky-submit-bar,\n  .form-tabs {\n    display: none !important;\n  }\n  \n  .public-form-container {\n    background: white;\n    padding: 0;\n  }\n  \n  .public-form {\n    box-shadow: none;\n    border: 1px solid #e5e7eb;\n    max-height: none;\n    padding-bottom: 0;\n  }\n  \n  .tab-content {\n    padding-bottom: 0;\n  }\n  \n  /* Show all tabs content when printing */\n  .document-upload-tab {\n    display: block !important;\n  }\n}\n\n/* Accessibility - Focus Visible States */\n@media (prefers-reduced-motion: no-preference) {\n  input:focus-visible,\n  textarea:focus-visible,\n  select:focus-visible {\n    outline: 2px solid #667eea;\n    outline-offset: 2px;\n  }\n  \n  .tab-button:focus-visible {\n    outline: 2px solid #667eea;\n    outline-offset: -2px;\n  }\n}\n\n/* High Contrast Mode Support */\n@media (prefers-contrast: high) {\n  input,\n  textarea,\n  select {\n    border-width: 2px;\n  }\n  \n  .btn-submit,\n  .submit-button,\n  .sticky-submit-button {\n    border: 2px solid currentColor;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
